export default __webpack_public_path__ + "c9ffe7854d5ec9dc72c578eb95243ae6.png";